import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getUser, logout } from '../actions/userAction';
import { exitSimulation, switchClient, getClientList, toggleDigitalFootprint } from '../actions/dataAction';
import styled, { css } from 'styled-components';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import Drawer from 'material-ui/Drawer';
import Popover from 'material-ui/Popover';
import ActionAccountCircle from 'material-ui/svg-icons/action/account-circle';
import ImageRemoveRedEye from 'material-ui/svg-icons/image/remove-red-eye';
import ActionPrint from 'material-ui/svg-icons/action/print';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import * as screenfull from 'screenfull';
import ToggleCheckBoxOutlineBlank from 'material-ui/svg-icons/toggle/check-box-outline-blank';
import ToggleCheckBox from 'material-ui/svg-icons/toggle/check-box';

const NavBar = styled.nav`
  transition: background-color 0.3s ease;
  border: 0;

  ${props => props && css`
    color: #4a4a4a !important;

    &.simulationMode {
      background:#000 !important;
    }
  `}

`;

const BoxButton = styled.button`
  padding: 0.25em 1em;
  margin: 0 1em;
  background: transparent;
  background-color: transparent !i;
  color: #fff;
  border: 0;
  position:absolute;
  left: 50%;
  height: 100%;
  transform: translateX(-50%)
`;

const Logo = styled.img`
  transition: all 0.3s ease;

  ${props => props && css`
    &.simulationMode {
      -webkit-filter: invert(1);
      filter: invert(1);
    }
  `}
`;

const IconButtonBox = styled(IconButton)`
  border-left: 1px solid #fbfbfb !important;
  height: 50px !important;
  width: 50px !important;
`;

const IconButtonMenuBox = styled(IconButton)`
  background-color: #56ba9a !important;
  height: 50px !important;
  width: 50px !important;
`;

const IconMenuContainer = styled.div`
  display: flex;
  align-items: center;
`;

const PopoverMenu = styled(Popover)`
  border-radius: 3px !important;
  margin-top: 8px;
  margin-left: -8px !important;
  overflow-y: initial !important;

  &:after {
    content: '';
    position: absolute;
    bottom: 100%;
    right: 12px;
    width: 0;
    height: 0;
    border-bottom: solid 5px #fff;
    border-left: solid 5px transparent;
    border-right: solid 5px transparent;
  }
`;

const MenuInnerPopover = styled(Menu)`
  > div > a {
    font-size: 12px !important;
    color: #666 !important;
    min-height: 26px !important;
    -webkit-transition: all 0.15s ease-in-out !important;
    -moz-transition: all 0.15s ease-in-out !important;
    -o-transition: all 0.15s ease-in-out !important;
    transition: all 0.15s ease-in-out !important;

    &:hover {
      color: #fff !important;
      background-color: #71bfa6 !important;
    }

    > div {
      line-height: 26px !important;
    }
  }
`;

const StyledNavBar = styled(NavBar)`
  border-radius: 0

  @media print {
    display: none;
  }
`;

const MobileMenuNavbar = styled.div`
  display: none !important;

  @media only screen and (max-width: 991px) {
    display: block !important;
  }
`;

const MobileMenuItem = styled(MenuItem)`
  font-size: 12px !important;

  ${props => props.profile && css`
    color: #fff !important;
    background-color: #5ab99a !important;

    > div > div {
      padding-left: 64px !important;
    }
  `}

  ${props => props.icon && css`
    > div > div {
      padding-left: 64px !important;
    }
  `}
`;

const MobileDivider = styled(Divider)`
  background-color: #f9f9f9 !important;
`;

const IconButtonNavbarToggle = styled(IconButton)`
  float: left;
`;

const DropdownMenu = styled.div`
  right: auto !important;
  max-height: 300px;
  overflow: scroll;
`;

const DropdownItem = styled.a`
  display: block;
  padding: 3px 5px;
`;

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      drawerOpen: false,
    };
  }

  componentDidMount() {
    const clients = this.props.data && this.props.data.clients;

    if (!clients) {
      this.props.getClientList();
    }

  }

  handleClick = (event) => {
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  handleToggle = () => this.setState({drawerOpen: !this.state.open});

  handleClose = () => this.setState({drawerOpen: false});

  handleFullscreen = () => {
    if(screenfull.enabled) {
      screenfull.toggle();
    }
  }

  handlePrint = () => {
    window.print();
  }

  simulationClass(className) {
    if (this.props.data.simulationMode) {
      className +=" simulationMode"
    }
    return className;
  }
  exitSimulation = (event) => {
      this.props.exitSimulation();
  }
  switchBrand(b) {
    switchClient(b);
  }
  toggleDigitalFootprint(val) {
    this.props.toggleDigitalFootprint(val);
  }
  clientSwitcher() {
    const clientName = this.props.user && this.props.user.userProfile && this.props.user.userProfile.client;
    const client = this.props.user && this.props.user.client;
    const isAdmin = this.props.user && this.props.user.userProfile && this.props.user.userProfile.isAdmin;
    const clients = this.props.data && this.props.data.clients;

    if (!isAdmin) {
      return null;
    }

    return (
      <div style={{display:'flex',alignItems: 'center', justifyContent: 'center'}}>
        <div style={{marginRight:'20px', float:'left',display:'flex',alignItems: 'center', justifyContent: 'center'}}>{client.digitalFootprint ? <ToggleCheckBox onClick={() => this.toggleDigitalFootprint(false)}/>:<ToggleCheckBoxOutlineBlank onClick={() => this.toggleDigitalFootprint(true)} />} <span style={{lineHeight:'20px'}}>Digital footprint</span></div>
        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
         Client: {clientName}
       </button>
       <DropdownMenu className="dropdown-menu">
        {clients && Object.keys(clients).map((client, i) => <DropdownItem className="dropdown-item" href="#" key={i} onClick={() => this.switchBrand(clients[client].name)}>{clients[client].name}</DropdownItem>)}
       </DropdownMenu>
      </div>
    )
  }
  render() {

    return (
        <StyledNavBar className={this.simulationClass("navbar auth")} style={{zIndex:'999'}}>
            <div>

                <MobileMenuNavbar>
                  <IconButtonNavbarToggle data-toggle="collapse" onClick={this.handleToggle}>
                    <NavigationMenu color="#5ab99a" />
                  </IconButtonNavbarToggle>

                  <Link className="navbar-brand" to="/">
                    <Logo src="/telescope.png" className={this.simulationClass("logo")}/>
                  </Link>

                  <Drawer
                    docked={false}
                    width={250}
                    open={this.state.drawerOpen}
                    onRequestChange={(drawerOpen) => this.setState({drawerOpen})}
                  >
                    {/*<MobileMenuItem profile primaryText="John Doe" onClick={this.handleClose} leftIcon={<ActionAccountCircle color="#fff" />} containerElement={<Link to="/" />} />*/}
                    <MobileMenuItem icon primaryText="Presentation mode" onClick={() => { this.handleClose(); this.handleFullscreen(); }} leftIcon={<ImageRemoveRedEye color="#606060" />} />
                    <MobileMenuItem icon primaryText="Print" onClick={() => { this.handleClose(); this.handlePrint(); }} leftIcon={<ActionPrint color="#606060" />} />
                    <MobileDivider />
                    <MobileMenuItem primaryText="User settings" onClick={this.handleClose} containerElement={<Link to="/settings" />} />
                    <MobileMenuItem primaryText="Logout" onClick={this.handleClose} containerElement={<Link to="/logout" onClick={() => this.props.logout()} />} onClick={() => this.props.logout()}/>
                  </Drawer>
                </MobileMenuNavbar>

                <div className="collapse navbar-collapse" id="myNavbar">
                  <Link className="navbar-brand" to="/">
                    <Logo src="/telescope.png" className={this.simulationClass("logo")}/>
                  </Link>

                  {this.props.data.simulationMode && <BoxButton
                      onClick={this.exitSimulation}
                    >
                      Exit Simulation
                    </BoxButton>}

                  {!this.props.data.simulationMode && (
                    <ul className="nav navbar-nav navbar-right">


                      {this.props.user === null ? (
                          <li>
                              <Link to="/login">Login</Link>
                          </li>
                      ) : (
                          <div>
                            <IconMenuContainer>
                              {this.clientSwitcher()}

                              <IconButtonBox tooltip="Presentation mode" onClick={this.handleFullscreen}>
                                <ImageRemoveRedEye color="#606060" />
                              </IconButtonBox>

                              <IconButtonBox tooltip="Print" onClick={this.handlePrint}>
                                <ActionPrint color="#606060" />
                              </IconButtonBox>

                              {/*
                              <IconButtonBox tooltip="Settings" containerElement={<Link to="/settings" />}>
                                <ActionSettings color="#606060" />
                              </IconButtonBox>

                              <IconButtonBox tooltip="Contact" containerElement={<Link to="/contact" />}>
                                <CommunicationPhone color="#606060" />
                              </IconButtonBox>
                              */}

                              <IconButtonMenuBox onClick={this.handleClick}>
                                <ActionAccountCircle color="#fff" />
                              </IconButtonMenuBox>
                              <PopoverMenu
                                open={this.state.open}
                                anchorEl={this.state.anchorEl}
                                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                                targetOrigin={{horizontal: 'right', vertical: 'top'}}
                                onRequestClose={this.handleRequestClose}
                              >
                                <MenuInnerPopover>
                                {/* <MenuItemName><p>John Doe</p></MenuItemName>
                                  <MenuItemRole><p>Admin</p></MenuItemRole>
                                  <DividerList />*/}
                                  <MenuItem primaryText="User settings" containerElement={<Link to="/settings" />} />
                                  <MenuItem primaryText="Data export" containerElement={<Link to="/export" />} />

                                  <MenuItem primaryText="Logout" containerElement={<Link to="/logout" onClick={() => this.props.logout()} />} onClick={() => this.props.logout()}/>
                                </MenuInnerPopover>
                              </PopoverMenu>
                            </IconMenuContainer>
                          </div>

                        )}
                    </ul>
                  )}

                </div>
            </div>
        </StyledNavBar>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        data: state.data
    };
}


export default withRouter(connect(mapStateToProps, { getUser, logout, exitSimulation, getClientList, toggleDigitalFootprint })(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js